// extracted by mini-css-extract-plugin
export var page404Title = "ScrollIndicator-module--page404-title--9CRP4";
export var progressContainer = "ScrollIndicator-module--progressContainer--s+Ujg";
export var progressIndicator = "ScrollIndicator-module--progressIndicator--gHrFP";